export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="/" className="text-lg font-bold text-foreground-950 tracking-tight">
              ACB Spreadsheet
            </a>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              This website is an independent informational resource and is not affiliated with AllChinaBuy unless explicitly stated.
            </p>
            <div className="mt-5">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium bg-primary-500 text-white rounded-md hover:bg-primary-600 transition-colors"
              >
                Visit Main Website
                <i className="ri-external-link-line" />
              </a>
            </div>
          </div>

          {/* Links Column 1 */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-950 uppercase tracking-wider mb-4">
              Spreadsheet
            </h3>
            <ul className="space-y-2.5">
              <li><a href="/allchinabuy-spreadsheet-guide/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">AllChinaBuy Spreadsheet</a></li>
              <li><a href="/allchinabuy-review/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">AllChinaBuy Review</a></li>
              <li><a href="/allchinabuy-shipping/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">AllChinaBuy Shipping Cost</a></li>
              <li><a href="/allchinabuy-warehouse/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">AllChinaBuy Warehouse</a></li>
            </ul>
          </div>

          {/* Links Column 2 */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-950 uppercase tracking-wider mb-4">
              Guides
            </h3>
            <ul className="space-y-2.5">
              <li><a href="/allchinabuy-coupon/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">AllChinaBuy Coupon</a></li>
              <li><a href="/allchinabuy-legit/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">AllChinaBuy Legit</a></li>
              <li><a href="/allchinabuy-qc/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">AllChinaBuy QC</a></li>
              <li><a href="/safety/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Safety</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-950 uppercase tracking-wider mb-4">
              Legal
            </h3>
            <ul className="space-y-2.5">
              <li><a href="/about/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">About Us</a></li>
              <li><a href="/contact/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Contact</a></li>
              <li><a href="/privacy-policy/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Privacy Policy</a></li>
              <li><a href="/terms/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Terms & Conditions</a></li>
              <li><a href="/disclaimer/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Disclaimer</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            AllChinaBuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              kaspreadsheet.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}